import { createSlice } from "@reduxjs/toolkit";
import { UserGroupData } from "./interface";

const INIT_STATE: {
  data: UserGroupData;
  selectedUserIds: string[];
} = {
  data: {
    id: "",
    title: "",
    searchTags: {
      defaultTag: []
    },
    status: "draft",
    expiryDate: null,
    shortDescription: "",
    stakeholder: {
      owner: [],
      reviewer: [],
      observer: []
    },
    dynamicGroup: false,
    cataloged: false,
    visibility: "PRIVATE",
    org: "",
    createdat: "",
    updatedat: "",
    createdby: "",
    updatedby: ""
  },
  selectedUserIds: []
};

export const UserGroupSlice = createSlice({
  name: "UserGroupSlice",
  initialState: INIT_STATE,
  reducers: {
    setGroupData(state, action) {
      state.data = action.payload;
    },
    mutateGroupData(state, action) {
      state.data = {
        ...state.data,
        ...action.payload
      };
    },
    addSelectedUser(state, action) {
      const newIds = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      // remove duplicate ids
      const unique = new Set([...state.selectedUserIds, ...newIds]);
      state.selectedUserIds = Array.from(unique);
    },
    removeSelectedUser(state, action) {
      const idsToRemove = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      state.selectedUserIds = state.selectedUserIds.filter(
        (id) => !idsToRemove.includes(id)
      );
    },
    toggleUserSelection(state, action) {
      const id = action.payload;
      if (state.selectedUserIds.includes(id)) {
        state.selectedUserIds = state.selectedUserIds.filter(
          (uid) => uid !== id
        );
      } else {
        state.selectedUserIds.push(id);
      }
    },
    clearSelection: (state) => {
      state.selectedUserIds = [];
    }
  }
});

export default UserGroupSlice;

export const UserGroupSliceActions = UserGroupSlice.actions;
